import React from 'react';

const ModeCard = ({ mode, color = 'green', description, models = [] }) => {
  const colorClasses = {
    green: {
      badge: 'bg-green-500/20 text-green-500',
    },
    purple: {
      badge: 'bg-violet-500/20 text-violet-500',
    },
    blue: {
      badge: 'bg-blue-500/20 text-blue-500',
    },
  };

  const colors = colorClasses[color] || colorClasses.green;

  return (
    <div className="bg-dark-tertiary border border-dark-border rounded-xl p-6">
      <div className={`inline-flex px-3 py-1.5 rounded-md text-xs font-semibold mb-4 ${colors.badge}`}>
        ◉ {mode}
      </div>
      <p className="text-zinc-400 text-sm leading-relaxed mb-4">
        {description}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {models.map((model, i) => (
          <span
            key={i}
            className="text-[11px] text-zinc-500 bg-dark-border px-2 py-1 rounded"
          >
            {model}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ModeCard;
